import React from 'react';
import PropTypes from 'prop-types';
import WalletProp from '../../proptype/walletProp';
import CommissionsWalletActions from './CommissionsWalletActions';
import CommissionsWalletCardList from './CommissionsWalletCardList';

export default function CommissionsWalletPicker(props) {
  const {
    wallets,
    activeWalletIndex,
    onPreviousWallet,
    onNextWallet,
    walletEnabled,
    onSeeTransactions,
    onWithdrawal,
  } = props;
  if (!walletEnabled || wallets.length === 0) {
    // Spacer so the rest of the page doesn't overlap the header
    return <div style={{ height: '60px' }} />;
  }
  const activeWallet = wallets[activeWalletIndex];
  return (
    <div className="commissions-wallet-picker-container">
      <div className="commissions-wallet-picker-section">
        <CommissionsWalletCardList
          activeWalletIndex={activeWalletIndex}
          onPreviousWallet={onPreviousWallet}
          onNextWallet={onNextWallet}
          wallets={wallets}
        />
      </div>
      <div className="commissions-wallet-picker-section">
        <CommissionsWalletActions
          onSeeTransactions={onSeeTransactions}
          onWithdrawal={onWithdrawal}
          activeWallet={activeWallet}
        />
      </div>
    </div>
  );
}

CommissionsWalletPicker.propTypes = {
  walletEnabled: PropTypes.bool.isRequired,
  wallets: PropTypes.arrayOf(PropTypes.shape(WalletProp.propType).isRequired)
    .isRequired,
  activeWalletIndex: PropTypes.number.isRequired,
  onNextWallet: PropTypes.func.isRequired,
  onPreviousWallet: PropTypes.func.isRequired,
  onSeeTransactions: PropTypes.func.isRequired,
  onWithdrawal: PropTypes.func.isRequired,
};
